import React from "react";
import i18n from "../../../../locale/i18n";
import PriceArrowUpDown from "../../../../components/ui/PriceArrowUpDown";
import { PRICE_STATUS, POSITIVE_CHANGE_NUMBER_FORMAT } from "../../../../constant/common";
import { useCompanySettings } from "../../../../hooks/useCompanySettings";
import { getCurrencyLabel } from "../../../../store/utils";
import { formatDateTime } from "../../../../utils";

const VictorAverageBasedCalculatorResults = ({ results, formatNumber, currency }) => {
    const companySettings = useCompanySettings();

    if (!results) {
        return null;
    }

    const currencyLabel = results.currency ? getCurrencyLabel(results.currency) : "";
    const positiveChangeFormat =
        companySettings.format?.positiveChangeFormat || POSITIVE_CHANGE_NUMBER_FORMAT;

    const isChangePositive = results.change >= 0;

    const calculationDateLabel = results.endDate ? formatDateTime(results.endDate, companySettings, true) : "";

    return (
        <div className="average-based-calculator-results template-victor">
            <div
                className={`average-based-calculator-results__box ${isChangePositive
                    ? "average-based-calculator-results__box--positive"
                    : "average-based-calculator-results__box--negative"
                    }`}
            >
                {calculationDateLabel && (
                    <div className="average-based-calculator-results__date-bar">
                        {calculationDateLabel}
                    </div>
                )}
                <div className="average-based-calculator-results__last-price-box-container">
                    <div className="average-based-calculator-results__last-price-box">
                        <div className="average-based-calculator-results__label">
                            {i18n.translate("lastTradingPrice")}
                        </div>
                        <div className="average-based-calculator-results__value">
                            <strong>{formatNumber(results.lastPrice)}</strong>{" "}
                            {currencyLabel && <span className="average-based-calculator-results__value-currency">
                                ({currencyLabel})
                            </span>}
                        </div>
                    </div>

                    <div className="average-based-calculator-results__metrics-grid">
                        <div className="average-based-calculator-results__item">
                            <div className="average-based-calculator-results__label">
                                {i18n.translate("totalAmountInvested")}{" "}
                                {currencyLabel && <span className="average-based-calculator-results__value-currency">
                                    ({currencyLabel})
                                </span>}
                            </div>
                            <div className="average-based-calculator-results__value">
                                {formatNumber(results.totalAmountInvested)}
                            </div>
                        </div>

                        <div className="average-based-calculator-results__item">
                            <div className="average-based-calculator-results__label">
                                {i18n.translate("currentValue")}{" "}
                                {currencyLabel && <span className="average-based-calculator-results__value-currency">
                                    ({currencyLabel})
                                </span>}
                            </div>
                            <div
                                className={`average-based-calculator-results__value ${isChangePositive
                                    ? "average-based-calculator-results__value--positive"
                                    : "average-based-calculator-results__value--negative"
                                    }`}
                            >
                                {formatNumber(results.currentValue)}
                            </div>
                        </div>

                        <div className="average-based-calculator-results__item">
                            <div className="average-based-calculator-results__label">
                                {i18n.translate("changePercentage")}
                            </div>
                            <div
                                className={`average-based-calculator-results__value ${isChangePositive
                                    ? "average-based-calculator-results__value--positive"
                                    : "average-based-calculator-results__value--negative"
                                    }`}
                            >
                                <PriceArrowUpDown
                                    status={
                                        results.change >= 0 ? PRICE_STATUS.UP : PRICE_STATUS.DOWN
                                    }
                                >
                                    <span>
                                        {formatNumber(Math.abs(results.change))}{" "}
                                        (
                                        {formatNumber(results.changePercentage, {
                                            positiveFormatPattern: positiveChangeFormat,
                                        })}
                                        %)
                                    </span>
                                </PriceArrowUpDown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="average-based-calculator-results__note">
                <strong>{i18n.translate("note")}:</strong>{" "}
                {i18n.translate("averageBasedCalculatorNote")}
            </div>
        </div>
    );
};

export default VictorAverageBasedCalculatorResults;


